import {UserAccountType} from './user-account-type';

export class UserAccount {
  id: number;
  by: string;
  name: string;
  nickname: string;
  email: string;
  position: number;
  isActive: boolean;
  phoneNumber: string;
  imagePhoto: string;
  imagePhotoBase64: string;
  userAccountTypeDefault: UserAccountType;
  userAccountTypes: UserAccountType[];
}



// WEBPACK FOOTER //
// ./src/app/shared/api/model/user-account.ts